import React from 'react';
import { classes } from './FacebookPost.st.css';
import { dataHooks, PUBLISH_DATE_JUST_NOW } from '../constants';
import { SocialPostPreviewProps } from '../SocialPostPreview.types';
import { Avatar, Text } from '../..';
import { CaptionWithEllipsis as Caption } from '../../Text/Caption';

export const FacebookPost: React.FC<
  Pick<
    SocialPostPreviewProps,
    'profileName' | 'profileImageSrc' | 'caption' | 'media'
  >
> = ({ profileName, profileImageSrc, caption, media }) => {
  const _renderAccountDetailsAndPublishDate = () => (
    <div className={classes.postHeader}>
      <Avatar
        size="size24"
        imgProps={{ src: profileImageSrc }}
        dataHook={dataHooks.socialPostPreviewProfileImage}
      />
      <div className={classes.profileNameAndPublishDate}>
        <Text
          size="tiny"
          weight="normal"
          dataHook={dataHooks.socialPostPreviewProfileName}
        >
          {profileName}
        </Text>
        <Caption
          className={classes.lastSeenCaption}
          tagName="span"
          caption="c1"
          dataHook="justNow"
          light={false}
        >
          {PUBLISH_DATE_JUST_NOW}
        </Caption>
      </div>
    </div>
  );

  const _renderCaption = () => (
    <div
      className={classes.postCaption}
      data-hook={dataHooks.socialPostPreviewCaption}
    >
      <Text size="tiny">{caption}</Text>
    </div>
  );

  const _renderMedia = () => (
    <div data-hook={dataHooks.socialPostPreviewMedia}>{media}</div>
  );

  return (
    <>
      {_renderAccountDetailsAndPublishDate()}
      {caption && _renderCaption()}
      {media && _renderMedia()}
    </>
  );
};
